import { Pipe, PipeTransform, inject } from '@angular/core';
import { OrderProductApiService } from '@mavles/orders';

@Pipe({
    name: 'productItem',
    pure: false,
    standalone: false
})
export class ProductItemPipe implements PipeTransform {
  private productService = inject(OrderProductApiService);


  transform(value: number): unknown {
    let name;
    try {
      this.productService.products.forEach(prd => {
        if(Number(prd.product_id) === Number(value)) {
          name = prd.product_name;
          return;
        }
      });
    } catch (error) {
      console.warn(error);
    }
    return name;
  }

}


